import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  ManualLanguagesData,
  ManualLanguageData,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { ManualsLanguageConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "manuals-language-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class ManualsLanguageChartComponent
  extends BaseChartLogic<ManualsLanguageConfig,ManualLanguagesData>
  implements OnInit, OnDestroy
{
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      ManualsLanguageConfig,
      _ngZone
    );
    this.handleDataSubscription(
      this.analyticsService.manualLanguagesDataChange
    );
  }

  dataPointKey: string = "Total";
  getDataPointDisplayValue(dataPoint: ManualLanguageData): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
  }

  refreshData(): void {
    this.analyticsService.getManualLanguagesData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
